import { Charts } from './Charts';
import ObjectsChartsDataProvider from './contexts/ObjectsChartsDataContext';

const ObjectsWrapper = () => {
    return (
        <ObjectsChartsDataProvider>
            <Charts />
        </ObjectsChartsDataProvider>
    );
};

export default ObjectsWrapper;
